import React from 'react';
import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% { background-position: -600px 0; }
  100% { background-position: 600px 0; }
`;

const Skeleton = styled.div`
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.backgroundInput} 25%,
    ${({ theme }) => theme.border} 50%,
    ${({ theme }) => theme.backgroundInput} 75%
  );
  background-size: 1200px 100%;
  animation: ${shimmer} 1.4s infinite linear;
  border-radius: 6px;
`;

const LayoutContainer = styled.div`
  height: 100vh;
  width: 100vw;
`;

const Container = styled.div`
  display: flex;
  height: calc(100vh - 36px);

  @media only screen and (max-width: 1200px) {
    height: max-content;
  }
`;

const LeftContainer = styled.div`
  padding: 0 80px;
  overflow: hidden;
  width: 65vw;
  height: 97vh;
  @media only screen and (max-width: 1200px) {
    padding: 0;
    width: 100%;
    height: max-content;
  }
`;

const ImageBanner = styled.div`
  width: 35vw;
  height: 100%;
  background: ${({ theme }) => theme.backgroundInput};

  @media only screen and (max-width: 1200px) {
    display: none;
  }
`;

const Footer = styled.div`
  background: ${({ theme }) => theme.backgroundInput};
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
`;

const HeaderPlaceholder = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
  padding-bottom: 60px;
  @media only screen and (max-width: 1200px) {
    padding: 18px 20px;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 24px;
`;

function LayoutPlaceholder() {
  return (
    <LayoutContainer>
      <Container>
        <LeftContainer>
          <HeaderPlaceholder>
            <Skeleton style={{ height: 50, width: 200 }} />
          </HeaderPlaceholder>
          <Content>
            <Skeleton style={{ height: 36, width: '50%' }} />
            <Skeleton style={{ height: 20, width: '90%' }} />
            <Skeleton style={{ height: 20, width: '75%' }} />
            <Skeleton style={{ height: 20, width: '60%' }} />
            <Skeleton style={{ height: 52, width: 180, marginTop: '2em' }} />
          </Content>
        </LeftContainer>
        <ImageBanner />
      </Container>
      <Footer />
    </LayoutContainer>
  );
}

export default LayoutPlaceholder;
